import { PropsWithChildren } from 'react'

export default function ItemCount({ children }: PropsWithChildren<{}>) {
  return (
    <div className="border-radius border-brand-primary/30 rounded-full border border-solid px-2.5 py-0.5 text-xs">
      <b className="text-brand-primary">{children}</b>
    </div>
  )
}
